<template>  
  <div class="crushing">
    <div class="section-image">
      <b-container>
        <b-row>
            <b-col>
              <h1 class="text-center section-name">KROSSNING</h1>
            </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-form-input v-model="search"
              type="text"
              placeholder="Sök läkemedel" class="drug-search"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="view-container">
      <b-row>
        <b-col>
          <div v-if="user.isAdmin">
            <hr>
            <div class="text-center">
              <router-link :to="'/krossning/editera/ny'">
                <mu-raised-button class="demo-raised-button" label="Lägg till läkemedel" icon="add" primary />
              </router-link>
              <router-link :to="'/krossning/anvisningar'">
                <mu-raised-button class="demo-raised-button" label="Redigera anvisningar" icon="edit" primary />
              </router-link>
            </div>
            <hr>
          </div>
          <ul class="drug-list">
            <li v-for="drug in filteredDrugList" v-bind:key="drug.recordKey">
              <b-row>
                <b-col cols="1" class="text-right">
                  <i class="fa fa-2x fa-angle-right"></i>
                </b-col>
                <b-col cols="10">
                  <router-link :to="'/krossning/' + drug.recordKey">
                  <h4 class="text-uppercase break-word" :class="!drug.isPublished ? 'text-muted' : ''">
                    {{ drug.recordHeading }}
                    <mu-icon v-if="!drug.isPublished" value="visibility_off" color="#7e57c2"/>
                  </h4>
                  <span>{{ drug.primaryDrugFormTextSv }} - {{ drug.exampleSilDrugNames.join(', ') }}</span>
                  </router-link>
                </b-col>
                <b-col>
                  <router-link :to="'/krossning/editera/' + drug.recordKey">
                    <mu-icon class="" v-if="user.isAdmin" value="edit" color="#7e57c2"/>
                  </router-link>
                </b-col>
              </b-row>
              </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { computed, onMounted, reactive, toRefs } from '@vue/composition-api'
import { some, toLower, includes } from 'lodash'
import { clickTracker } from '@/services/helpers'
import axios from 'axios'

export default {
  name: 'Crushing',
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  setup () {
    const state = reactive({
      search: '',
      crushingRecordList: []
    })
    onMounted(() => {
      getCrushingRecordList()
      clickTracker('keyCrushingList')
    })

    function getCrushingRecordList () {
      axios.get('crushingapi/getCrushingRecordPresentationList')
        .then((result) => {
          state.crushingRecordList = result.data
        })
        .catch((error) => {
          console.log(error)
        })
    }

    const filteredDrugList = computed(() => {
      return state.crushingRecordList.filter(drug =>
        includes(toLower(drug.recordHeading), toLower(state.search)) ||
          some(drug.exampleSilDrugNames, name => includes(toLower(name), toLower(state.search)))
      )
    })

    return {
      ...toRefs(state),
      filteredDrugList
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.demo-float-button {
  margin-right: 12px;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  padding-left: 10px;
}

ul li {
  list-style: none;
}

.drug-search {
  margin: 20px 0;
  padding: 10px;
}

.drug-list {
  h4 {
    margin-top: 1rem;
    margin-bottom: 0;
  }
  i.fa {
    color: $orange;
    margin-top: 20px;
  }
}

.section-name {
  color: $white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888;
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 170px;
  width: 100%;
  background-image: url("../assets/crushing-background.jpg");
  background-position-y: bottom;
  background-size: cover;
}

.view-container {
  padding-top: 0;
}
</style>
